import { useCallback, useMemo } from 'react'

import AdminSidebar from '@/modules/admin/Sidebar'
import CMSSidebar from '@/modules/cms/Sidebar'
import OfferSidebar from '@/modules/offer/Sidebar'
import PathSidebar from '@/modules/path/Sidebar'
import ReportSidebar from '@/modules/report/Sidebar'
import { CustomReportProvider } from '@/modules/report/views/custom/store'
import SettingSidebar from '@/modules/settings/Sidebar'
import { useGlobalStore } from '@Stores/global'
import { useGlobalAuthStore } from '@Stores/global/auth'

function CMSModuleSidebar() {
  const { siteSettings: { useThemeConfig } } = useGlobalStore()
  const typesConfig = useThemeConfig('types')
  const types = useMemo(() => typesConfig ? Object.entries(typesConfig) : null, [typesConfig])

  return <CMSSidebar types={types} />
}

function ReportModuleSidebar() {
  const { auth: { menuPermissions } } = useGlobalAuthStore()
  const permission = menuPermissions.map(menu => menu.key)
  const hasPermission = useCallback(mod => permission.includes(mod), [permission])

  return <CustomReportProvider>
    <ReportSidebar hasPermission={hasPermission} />
  </CustomReportProvider>
}

const moduleSidebars = {
  '/path': <PathSidebar />,
  '/cms': <CMSModuleSidebar />,
  '/offer': <OfferSidebar />,
  '/reports': <ReportModuleSidebar />,
  '/settings': <SettingSidebar />,
  '/admin': <AdminSidebar />,
}

export default moduleSidebars
